import { useContext, useEffect, useRef, useState } from "react";

import { CourseTableComp, SuggestCourseTableComp } from "../components/courseTableComp";

import { GridLayout, HorizontalLayout, HorizontalPageLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import {  EmptyActivitiesComp, RecentActivities } from "../components/recentActivities";
import { TopBar } from "../components/topbar";
import { ReportsOverview } from "../molecule/reportsOverview";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { SuggestedCourseGrid } from "../components/suggestCourse";
import { Alert } from "../components/alert";
import { SuggestionModal } from "../components/customModals";
import { DropdownButton, GoBackButton, StandardButton } from "../atoms/buttons";
import { HeaderTitle } from "../molecule/headerTitle";
import { ShowLayoutError } from "../molecule/ShowErrorLayout";
import { Toast } from "../atoms/toast";
import { vi } from "date-fns/locale";
import { PageContext, ToastContext, UserContext } from "../App";
import { formatDistanceToNow, set } from 'date-fns';
import { nl } from 'date-fns/locale';
import { SubTextAtom, TextAtom } from "../atoms/TextAtom";
import { ProgressBarComplete } from "../molecule/timeBar";
import { IconAtom } from "../atoms/iconAtom";

import { TitleAtom } from "../atoms/titleAtom";

import { PagePagination } from "../molecule/PagePagination";
import { useFeatures } from "../FeaturesContext";
import { ChipFilter } from "../molecule/Chip";

import { icon } from "../functions/icons";
import { Spinner } from "../atoms/spinner";
import { relativeTime } from "../api/date_formatting";


export function Reports({ pageSwap,CustomerStage }) {
    const [suggestionVisible, setSuggestionVisible] = useState(false);
    const openSuggestionModal = () => setSuggestionVisible(true);
    const closeSuggestionModal = () => setSuggestionVisible(false);
    const [kpiContents, setKpiContents] = useState({})
    const [showMore, setShowMore] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [selectedCourseIds, setSelectedCourseIds] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [userCourseStats, setUserCourseStats] = useState([]);
    const navigationContext = useContext(PageContext);
    const { isFeatureEnabled } = useFeatures();
    const isPublic = navigationContext.sidebar.account_type === 1;
    useEffect(() => {
        
        loadCourses();
    }, []);

    const loadCourses = async () => {
        const query = `api/courses/filter?filter=creation_date&order=DESC&published_filters=active_lessons&customer_stage=${CustomerStage}`;
        const response = await getAPI(query);
        const courses = response.data;
        setAllCourses(courses);
    };
        useEffect(() => {
        if (navigationContext.sidebar?.courseID && allCourses.length > 0) {
            const id = navigationContext.sidebar.courseID;
            handleCourseToggle(id, true);
        }
    }, [allCourses, navigationContext.sidebar?.courseID]);
      const handleCourseToggle = (id, override = false) => {
        setErrorMessage("");
        if (override) {
            setSelectedCourseIds([id]);
            return;
        }


        setSelectedCourseIds((prev) => {
            if (prev.includes(id)) {
                const newSelected = prev.filter((cid) => cid !== id);
                setUserCourseStats(allCourses.filter(course => newSelected.includes(course.id_course)));
                return newSelected
            } else {
                if (prev.length >= 5) {
                    setErrorMessage("Je kunt maximaal 5 cursussen selecteren.");
                    setTimeout(() => {
                        setErrorMessage("");
                    }, 3500);
                    return prev;
                }

                const newSelected = [...prev, id];
                setUserCourseStats(allCourses.filter(course => newSelected.includes(course.id_course)));
            
                return newSelected;
            }
        });
        
    };

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); 
        };
        checkMobile();

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    const displayedCourses = showMore ? allCourses : (isMobile ? allCourses.slice(0, 2) : allCourses.slice(0, 4));
    if (allCourses.length === 0 && kpiContents.length === 0) {
        return (
            <ShowLayoutError
                iconType="no-reports"
                errorTitle="Geen suggesties beschikbaar"
                message="Er zijn momenteel geen rapportages of aanbevelingen om weer te geven."
            />
        );
    }
    if (CustomerStage != 5) return (<LeadStatsComp />)
    return (
        <>
            {errorMessage && (
                <Toast
                    className={"max-course-alert"}
                    message={errorMessage}
                    type="error"
                    duration={3500}
                />
            )}
            {suggestionVisible && (
                <SuggestionModal
                    ref={null}
                    visible={suggestionVisible}
                    dismiss={closeSuggestionModal}
                    position={"center"}
                />
            )}


            <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
                <HorizontalLayout style={{ width: "auto" }} className={"standard-padding"}>
                    <HeaderTitle title={"Rapporten"} />
                    <StandardButton className={"show-button"} size="medium" title={showMore ? "Toon minder" : "Toon meer"} onClick={() => setShowMore(!showMore)} />
                </HorizontalLayout>
                {allCourses.length > 0  && <SuggestedCourseGrid showMore={showMore}  selectedCourseIds={selectedCourseIds} selectCourse={handleCourseToggle} coursesToDisplay={displayedCourses} />}
                { isFeatureEnabled(16)  && <Alert onClick={openSuggestionModal} className={"suggest-alert"} type="suggestion" buttonText={"Leer meer"} title={"Suggesties"} message={"Leer hoe je het maximale uit je e-learning kan halen met onze op maat gemaakte suggesties."} /> }
                <VerticalLayout className="phone-raports-container">
                    <ReportsOverview selectedCourses={selectedCourseIds} courses={allCourses} />
                </VerticalLayout>
                <Tables selectedCourseIds={selectedCourseIds} userCourseStats={userCourseStats} />
            </VerticalPageLayout>
        </>

    );
}

const LeadStatsComp = () => {
    const [leadID, setLeadID] = useState(null);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const navigationContext = useContext(PageContext);
    const [selectedCourseIds, setSelectedCourseIds] = useState([]);
    const [channelTypes, setChannelTypes] = useState([]);
    const [courses, setCourses] = useState([]);
    const [leads, setLeads] = useState([]);
    const [stats, setStats] = useState({});
    const [engagementStats, setEngagementStats] = useState({});
    const [activities, setActivities] = useState([]);
    const [leerpersona, setLeerpersona] = useState("");
    const [loading, setLoading] = useState(false);
    const autoResetRef = useRef(false);
    const toastContext = useContext(ToastContext)
    const getActiveLeadID = () => {
        return leadID || navigationContext.sidebar?.id_lead || null;
    }
    const activeLeadID = getActiveLeadID();
    const loadStats = async () => {
      
        setLoading(true);
        const query = `api/reports/leads/${activeLeadID}?channel_types=${selectedChannels.join(",")}`;
        console.log(query)
        const body = {}
        const res = await getAPI(query, body)
        console.log("leads stats", res)
        if (res.status === "ok") {
            const data = res.data;
            if (data.channel_filter_failed) {
                autoResetRef.current = true;
                setSelectedChannels([]);
                toastContext.showToast("Deze lead heeft geen data voor de gekozen kanalen. Algemene statistieken worden getoond.", "error");
            }
            setStats(data);
            setChannelTypes(data.channels || []);
            setCourses(data.courses || []);
            setLeads(data.leads || []);
            setEngagementStats(data.engagement || {});
            setActivities(data.activities || []);
            setLeerpersona(data.leads.find(l => l.id_lead === activeLeadID)?.leerpersona || "");
        }
        setLoading(false);
    };
    useEffect(() => {
        if (autoResetRef.current) {
            autoResetRef.current = false;
            return;
        }
        loadStats();
    }, [leadID, selectedChannels, selectedCourseIds, navigationContext.sidebar.id_lead]);
    const handleGoBack = () => {
        setLeadID(null);
        navigationContext.handleNavigation({ ...navigationContext.sidebar, back_page: 11, navigation: 20, id_lead: null });
    }
    if (loading)return <VerticalPageLayout className={"center"}><Spinner /></VerticalPageLayout>
    return (
        <HorizontalPageLayout className="phone-column" style={{ alignItems: "flex-start"}}>
            <LeadSideBar leads={leads} setLeadID={setLeadID} leadID={activeLeadID} />
            <VerticalLayout className="standard-padding lead-stats-content" style={{ gap: "1rem" }}>
                <HorizontalLayout>
                    {navigationContext.sidebar.id_lead && <GoBackButton left={true} onClick={() => handleGoBack()}/>}
                    <ChannelTypesFilter channels={channelTypes} selectedChannels={selectedChannels} setSelectedChannels={setSelectedChannels} />
                </HorizontalLayout>
                 <HorizontalLayout className="phone-column" style={{ gap: "1rem", alignItems: "flex-start", width: "auto" }}>
                    <VerticalLayout className="lead-course-activity-container" style={{ width: "65%", gap: "1rem" }}>
                        <LeadCourseProgress courses={courses} />
                        <LeadActivities activities={activities} />
                    </VerticalLayout>
                    <VerticalLayout className="lead-engagement-suggestion-container" style={{ width: "35%", height: "100%", gap: "1rem" }}>
                        <LeadEngagement engagementStats={engagementStats} />
                        {false && <LeadSuggestion leerpersona={leerpersona} lead={activeLeadID} />}
                    </VerticalLayout>
                </HorizontalLayout>
            </VerticalLayout>
        </HorizontalPageLayout>
        
    )
}
const LeadActivities = ({ activities }) => {    
    const isEmpty = activities.length === 0;
    return(
        <VerticalLayout className="lead-report-box " style={{ width: "auto", padding: ".75rem", maxHeight: isEmpty ? "unset" : "15rem", height: isEmpty ? "unset" : "15rem", overflowY: "auto" }}>
            {!isEmpty && (
                <div className="phone-activity-content" style={{ position: "relative" }}>
                    <div style={{ height: "calc(100% - 1rem)", borderRight: "1px dashed #ccc", position: "absolute", left: "1.2rem" }}></div>
                    {activities.map((activity, index) => (
                        <ActivitiesComp key={index} activity={activity} />
                    ))}
                </div>
            )}
            {isEmpty && <EmptyActivitiesComp />}
        </VerticalLayout>
    )
}

const ActivitiesComp = ({ activity }) => {

    const activityType = activity.interaction_label
    const activityIcon = activity.interaction_type
    const activityName = activity.course_title
    const userName = `${activity.first_name} ${activity.last_name}`
    const activityLabelColor = activity.interaction_type === "opened_embed" ? "var(--primary-500)" : activity.interaction_type === "started_embed" ? "var(--warning-500)" : activity.interaction_type === "finished_assessment" ? "var(--success-500)" : "var(--standard-text-color)"
    const iconColor = activity.interaction_type === "opened_embed" ? "var(--primary-500)" : activity.interaction_type === "started_embed" ? "var(--warning-500)" : activity.interaction_type === "finished_assessment" ? "var(--success-500)" : "var(--standard-text-color)"
    return (
        <div className="horizontal complete-width standard-small-margin-bottom" style={{ alignItems: "unset" }}>
            
            <div className="standard-border standard-rounded medium-icon">
                <IconAtom icon2={activityIcon} color={iconColor} />
            </div>

            <VerticalLayout>
                <div className="horizontal">    
                    <p className="small-text-light" style={{ color: activityLabelColor }}>
                        {activityType}
                    </p>
                    <p className="small-text-light">&nbsp;• {userName}</p>
                </div>

                <div className="horizontal complete-width space-between">
                    <p className="small-text-dark">{activityName}</p>
                    <p className="small-text-light">
                        {relativeTime(new Date(activity.start_time), true)}
                    </p>
                </div>
            </VerticalLayout>
        </div>
    );
}
const LeadEngagement = ({ engagementStats }) => {
    const channels = [
        { label: "Cursusmateriaal", value: engagementStats.cursus_percentage},
    ];

    return (
        <VerticalLayout className="lead-report-box standard-padding" style={{ gap: "1rem", width: "auto", height:"fit-content" }}>
            <TitleAtom title="Lead engagement" />
            <GridLayout rowTemplate="1fr 1fr" columnsTemplate="repeat(2, 1fr)" gap=".75rem">
                <div className="lead-kpi-card">
                    <SubTextAtom title="Open count" />
                    <TitleAtom title={engagementStats.open_count} />
                    <HorizontalLayout>
                        {icon(`trend-${engagementStats.difference?.direction}`, 16, engagementStats.difference?.direction === "flat" ? "var(--primary-500)" : engagementStats.difference?.direction === "up" ? "var(--success-500)" : "var(--error-500)")}
                        <SubTextAtom className={"xsmall-text"} title={engagementStats.difference?.value} style={{ color: `var(--${engagementStats.difference?.direction === "flat" ? "primary" : engagementStats.difference?.direction === "up" ? "success" : "error"}-500)` }} />
                    </HorizontalLayout>
                </div>
                <div className="lead-kpi-card">
                    <SubTextAtom title="Engagement" />
                    <TitleAtom title={engagementStats.engagement_level} />
                    <SubTextAtom className={"xsmall-text"} title={engagementStats.rank_label} style={{ color: "var(--primary-500)" }}/>
                </div>
                <div className="lead-kpi-card">
                    <SubTextAtom title="Gem. Interacties" />
                    <TitleAtom title={engagementStats.avg_interactions} />
                </div>
                <div className="lead-kpi-card">
                    <SubTextAtom title="Voltooiingsgraad" />
                    <TitleAtom title={`${engagementStats.completion_rate}%`} />
                </div>

            </GridLayout>

            <VerticalLayout style={{ gap: ".75rem" }}>
                <SubTextAtom title="Kanaal diepte" className="uppercase small-text" />
                {channels.map((channel, i) => (
                    <VerticalLayout key={i} style={{ gap: ".25rem" }}>
                        <HorizontalLayout className="space-between">
                            <TextAtom title={channel.label} />
                            <TextAtom title={`${channel.value}%`} />
                        </HorizontalLayout>
                        <ProgressBarComplete progress={channel.value} />
                    </VerticalLayout>
                ))}
            </VerticalLayout>
        </VerticalLayout>
    );
};

const LeadSuggestion = ({ leerpersona, lead }) => {
    return (
        <VerticalLayout className="lead-report-box standard-padding" style={{ background: "var(--primary-600)", color: "var(--white)",gap: ".75rem",width: "auto",}} >
            <HorizontalLayout style={{ gap: ".5rem", alignItems: "center", justifyContent: "center" }}>
                <IconAtom icon2="brain" color="white" iconSize={24} />
                <TitleAtom className={"leerpersona"} title="Leerpersona" />
            </HorizontalLayout>

            <TextAtom
                title={lead ? `${leerpersona}` : `Selecteer een lead om de leerpersona te zien.`}
                className="xsmall-text"
            />
        </VerticalLayout>
    );
};

const LeadCourseProgress = ({ courses }) => {
    const [showAll, setShowAll] = useState(false);
    const navigationContext = useContext(PageContext);
    const handleShowAll = () => {
        setShowAll(prev => !prev);
    };
    const GoToCourse = (id_course) => {
        navigationContext.handleNavigation({...navigationContext.sidebar, courseID: id_course, navigation: 7, back_page: 11})
    }
    const visibleCourses = showAll ? courses : courses.slice(0, 2);
    console.log("rendering progress", courses, visibleCourses);
    return (
        <VerticalLayout style={{ height: "auto" }}>
            <HorizontalLayout>
                <TitleAtom title={"Voortgang per cursus"} className={"standard-margin"} />
                {courses.length > 2 && (
                    <StandardButton
                        textColor="primary-500"
                        backgroundColor="transparent"
                        title={showAll ? "Minder zien" : "Alles zien"}
                        onClick={handleShowAll}
                    />
                )}
            </HorizontalLayout>

            <GridLayout className="lead-progress-grid" columnsTemplate="repeat(2, 1fr)" gap=".5rem">
                {visibleCourses.map(course => (
                    <LeadProgressObj
                        key={course.id_course}
                        title={course.course_name}
                        percentage={Number(course.progress)}
                        onClick={()=> GoToCourse(course.id_course)}
                    />
                ))}
            </GridLayout>
            {courses.length === 0 && <EmptyComponent message="Geen cursussen beschikbaar" icon="book" />}
        </VerticalLayout>
    );
};

const LeadProgressObj = ({ data, onClick, image, title, percentage,description, className, message}) => {
  const imgSrc = image || `https://ui-avatars.com/api/?name=${title}`;
  console.log("rendering progress obj", {data, title, percentage})
  const displayTitle = data?.course_name || title || "Geen titel beschikbaar";
  const displayDescription = data?.course_description || description || "Geen beschrijving beschikbaar";
  return (
    <div className={`progress-comp ${className}`} onClick={onClick} style={{ height: "auto", minHeight: "unset", padding: "1rem" }}>
      <div className="fadeable" style={{ gap: ".5rem" }}>
        <img className="course-img" style={{ borderRadius: "calc(.5rem * var(--br-scale))" }} src={imgSrc} alt={title} />
        <TitleAtom className={"medium-text"} title={displayTitle} />
        <HorizontalLayout className="space-between" style={{ width: "unset" }}>
            <TitleAtom className={"small-text-light"} title={"Voortgang"} />
            <TitleAtom className={"xsmall-text"} style={{ color: "var(--primary-500)", width: "unset" }} title={`${percentage}%`} />
        </HorizontalLayout>
        
        {!message && percentage !== "none" && <ProgressBarComplete progress={percentage} />}
      </div>
      {message && (  <Alert className="alert-no-entry" type="warning" message={message} /> )}
    </div>  
  );
};

const ChannelTypesFilter = ({ channels, selectedChannels, setSelectedChannels }) => {
    const options = (channels || []).map((channel )=> ({
        id: channel.channel_type, 
        label: channel.channel_type
    }));
    const handleSelectChannels = (id) => {
        setSelectedChannels(prev =>
            prev.includes(id)
                ? prev.filter(c => c !== id) 
                : [...prev, id]
        );
    };
    return (
        <HorizontalLayout style={{ width: "auto" }}>
            {options.length > 0 && <ChipFilter id_name="id" options={options} onSelect={handleSelectChannels} selected={selectedChannels}/>}
            {options.length === 0 && <EmptyComponent message="Geen kanalen beschikbaar" icon="info" />}
        </HorizontalLayout>
    )
}
const LeadSideBar = ({ leads, setLeadID, leadID }) => {

    return (
        <VerticalLayout className="lead-sidebar phone-row" style={{ gap:".5rem" }}>
            <HeaderTitle title={"Lead Voortgang"} />
            {leads.map(lead => (
                <LeadCard key={lead.id_lead} selected={leadID === lead.id_lead} lead={lead} setLeadID={setLeadID}/>
            ))}
            {leads.length === 0 && <EmptyComponent message="Geen leads beschikbaar" icon="info" />}
        </VerticalLayout>
    )
}
const LeadCard = ({ lead, setLeadID, selected }) => {
    const name = lead.first_name || lead.last_name || lead.email || lead.company_name || "";
    const avatar = lead.avatar || `https://ui-avatars.com/api/?name=${name}&background=random&color=fff&format=svg`;
    const handleToggleLead = () => {
        setLeadID(prev =>
            prev === lead.id_lead ? null : lead.id_lead
        );
    };
    return (
        <HorizontalLayout className={`lead-card ${selected ? "selected" : ""}`} style={{ gap: ".75rem", alignItems: "center" }} onClick={handleToggleLead}>
            <img className="avatar-lead-card" src={avatar} alt="avatar" />
            <VerticalLayout className="center">
                <TitleAtom title={name} className={"small-text lead-name"} />
                {lead.company_name && <TitleAtom title={lead.company_name} className={"xsmall-text standard-text-color-light lead-company"} />}
            </VerticalLayout>
        </HorizontalLayout>
    )
}

const EmptyComponent = ({ message = "Geen data beschikbaar", icon = "info" }) => {
    return (
        <VerticalLayout
            className="empty-component"
            style={{
                width: "auto",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
                color: "var(--standard-text-color-light)",
                textAlign: "left",
                padding: "1rem",
                border: "1px dashed var(--standard-border-color)",
                borderRadius: "0.5rem",
                background: "var(--white)",
            }}
        >
            <IconAtom icon2={icon} color="var(--standard-text-color-light)" iconSize={24} />
            <p className="small-text-light">{message}</p>
        </VerticalLayout>
    );
};
const Tables = ({userCourseStats, selectedCourseIds}) => {
    const userContext = useContext(UserContext)
      
    const isPublic  = userContext.account_type === 1
    const isMobile = window.innerWidth < 768;
    const title = isPublic ? "Leads":"Cursiststatistieken"
    return (
        isMobile ? (
            <MobileCard selectedCourseIds={selectedCourseIds} userCourseStats={userCourseStats} />
        ) : (
            <VerticalLayout className="phone-raports">
                <SuggestCourseTableComp margin={"0.8rem"} title={title} courses={userCourseStats} />
            </VerticalLayout>
        )
       
    )
}

const MobileCard = ({ userCourseStats, selectedCourseIds }) => {
    const userContext = useContext(UserContext);
    const isPublic = userContext.account_type === 1;
    const [page, setPage] = useState(0);
    const [selectedCourseByUser, setSelectedCourseByUser] = useState(selectedCourseIds[0] || {});
    const title = isPublic ? "Leads" : "Cursiststatistieken";
    const itemsPerPage = 3;
    const [userStats, setUserStats] = useState([]);
   
    const loadUserCourseStats = async (course) => {
        const query = `api/reports/table-stats?id_course=${course || 0}`;
        const res = await getAPI(query);
        console.log("user course stats", res);
        if (res.status === "ok") {
            setUserStats(res.data);
            setPage(0);
        }
    };
    const handleGlobalCourseSelect = (courseId) => {
        setSelectedCourseByUser(courseId);
        loadUserCourseStats(courseId);
    };
    useEffect(() => {
        loadUserCourseStats();
    }, []);
    useEffect(() => {
        if (selectedCourseIds?.length > 0) {
            const newCourse = selectedCourseIds[0];
            setSelectedCourseByUser(newCourse);
            loadUserCourseStats(newCourse);
        }
    }, [selectedCourseIds]);
    console.log("selectedCourseByUser", selectedCourseByUser);
    const GetSelectedCourseTitle = (courseId) => {
        const course = userCourseStats.find(c => c.id_course === courseId);
        return course ? course.title : "Selecteer cursus";
    }
    const pagedUserStats = userStats.slice(page * itemsPerPage, (page + 1) * itemsPerPage);
  return (
    <VerticalLayout className="standard-margin phone-table" style={{ width: "auto", gap: "1rem" }}>
        <HorizontalLayout>
            <HeaderTitle title={title || "Statistieken"} />
            <DropdownButton
                content={GetSelectedCourseTitle(selectedCourseByUser)}
                dropdown={userCourseStats.map((course, index) => ({ id: course.id_course, content: course.title, index: index }))}
                optionSelected={handleGlobalCourseSelect}
                classButton="dropdown-course-button"
                classContent="dropdown-course-menu"
                width="100%"
                dropdownStyle={{ top: "0", right: "0", left: "unset", }}
            />
        </HorizontalLayout>
      <VerticalLayout className="user-card-container">
        {pagedUserStats.map((u) => {
          return (
            <UserCard key={u.id_lead || u.user_id} user={u}/>
          );
        })}
      </VerticalLayout>
      <PagePagination itemsPerPage={itemsPerPage} onPageChange={setPage} currentPage={page} totalUnits={userStats.length} unitName={title} />
    </VerticalLayout>
  );
};

const UserCard = ({ user }) => {
    const progress = user.finish_time ? 100 : (user.progress ?? 0);
    const name = user.first_name || user.last_name || user.email || user.company || "";
    const avatar = user.avatar || `https://ui-avatars.com/api/?name=${name}&background=random&color=fff&format=svg`;
    const formatRelative = (date) => date ? `Laatste activiteit: ${formatDistanceToNow(new Date(date), { addSuffix: true, locale: nl })}` : "Geen activiteit";
    const formatStart = (date) => date ? `Gestart op: ${new Date(date).toLocaleDateString("nl-NL")}` : "Niet gestart";
    return(
         <VerticalLayout className="user-card" key={user.id_lead || user.user_id} style={{ width: "auto", }}>
            <HorizontalLayout style={{ gap: "1rem", alignItems: "flex-start" }}>
            <img className="avatar-user-card" src={avatar} alt="avatar"/>
            <VerticalLayout style={{ flex: 1, gap: "0.5rem" }}>
                <VerticalLayout>
                    <TitleAtom title={name} />
                    <TextAtom className={"standard-text-color-light"} title={formatStart(user.start_time)} />
                </VerticalLayout>
                <SubTextAtom title={user.finish_time ? "Afgerond" : "In uitvoering"} className={"small-text"} />
                <VerticalLayout className="user-card-progress" style={{ width: "auto", }}>
                    <ProgressBarComplete barColor={user.finish_time ? "success-500" : "primary-500"} progress={`${progress}%`} />
                    {user.finish_time ? (
                        <IconAtom iconSize={20} color={"success-500"} icon2={"check-circle-no-fill"} />
                    ) : (
                        <TextAtom title={`${progress}%`} className={"small-text"} />
                    )}
                </VerticalLayout>
            </VerticalLayout>
            </HorizontalLayout>
            <SubTextAtom title={formatRelative(user.last_activity)} className={"small-text standard-small-margin-top divider-top user-card-last-seen"} />
        </VerticalLayout>
    )
}
